import { useTranslation } from "react-i18next";
import { ContactDetailsSectionBreadcrumbs } from "../ContactDetailsSectionBreadcrumbs";
import { ContactDetailsSections } from "../../../ContactsDialog";
import { TellescopeModelFromName } from "@tellescope/tanstack-query";

export interface InformationSectionProps {
  enduser: TellescopeModelFromName<"endusers">;
}

export const InformationSection = ({ enduser }: InformationSectionProps) => {
  const { t } = useTranslation("contacts");

  return (
    <div className="flex flex-col gap-4 overflow-y-hidden">
      <ContactDetailsSectionBreadcrumbs enduserId={enduser.id} breadcrumbs={[{ title: t("Information") }]} />
      <div className="overflow-y-auto">
        <ContactDetailsSections.InformationSection contact={enduser} />
      </div>
    </div>
  );
};
